import { readCookie } from '../helpers/read-write-cookies';

export function loadMyKitCookie() {
    const raw = readCookie('myKit');
    if (!raw) return {};

    const tryParse = (s) => {
        try { return JSON.parse(s); } catch { return null; }
    };

    // 1) Try as-is
    let val = tryParse(raw);

    // 2) If that fails, try URL-decoding (handle + as space too)
    if (!val) {
        let decoded = raw;
        try {
            decoded = decodeURIComponent(raw.replace(/\+/g, '%20'));
        } catch {}
        val = tryParse(decoded);
    }

    // 3) Handle double-encoded JSON (cookie value is a JSON string that contains JSON)
    if (typeof val === 'string') {
        const inner = tryParse(val);
        if (inner && typeof inner === 'object' && !Array.isArray(inner)) {
            val = inner;
        }
    }

    // 4) Ensure we return a plain object
    if (!val || typeof val !== 'object' || Array.isArray(val)) {
        return {};
    }

    return val;
}
